import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
// import { Api } from '@/service';
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import PartnerList from '../../../Management/partner/partner.List.i18n';
import { Switch as cSwitch } from '@coreui/vue';

//restful api
import { mail as setting } from '@/service/api/setting'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

const i18n_fields = {
  EN: [
    { key: 'id', thStyle: 'width: 5%', sortable: true, label: 'No.' },
    { key: 'is_alive', thStyle: 'width: 10%', sortable: false, label: 'Status' },
    { key: 'cmd', thStyle: 'width: 10%', sortable: false, label: 'Cmd'},
    { key: 'level', thStyle: 'width: 10%', sortable: false, label: 'Level'},
    { key: 'title', sortable: false, label: 'Title' },
    // { key: 'updated_at', thStyle: 'width: 15%', sortable: true, label: 'Last updated' }, //날짜가 정확하지않아 주석처리 [일감 #5525, #5772 참고]
  ],
  KO: [
    { key: 'id', thStyle: 'width: 5%', sortable: true, label: '#.' },
    { key: 'is_alive', thStyle: 'width: 10%', sortable: false, label: '상태' },
    { key: 'cmd', thStyle: 'width: 10%', sortable: false, label: '명령줄'},
    { key: 'level', thStyle: 'width: 10%', sortable: false, label: '위험 수준'},
    { key: 'title', sortable: false, label: '제목' },
    // { key: 'updated_at', thStyle: 'width: 15%', sortable: true, label: '마지막 보낸 날짜' },
  ]
}

export default {
  components: { DatePicker, vSelect, PartnerList, cSwitch },
  props : ["auto_refresh", "enable_new", "view_detail"],
  name : "MailList",
  data: () => ({
    partner_name : '',
    chainPartner : false,
    custom,
    codes,
    datepicker,
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0 },
    sync : { interval : 15, stop : false, th : undefined },
    is_loading : true,
    item : {},
    confirm : false,
    nbsp: "\u00A0",
    hide_del : true,
  }),
  filters: {
    level(v) {
      return v;
    }
  },
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      // if(this.user) { f.splice(1, 1) }
      return i18n_fields[this.i18n]
    }
  },
  methods: {
    async toggle() {
      // 모달 확인 필요할 수 있음
      let model = Object.assign({}, this.item)
      delete model.category_code
      delete model.target_code
      // model.is_alive = !model.is_alive


      try{
        // let rs = await Api.Manager_Call('mail', 'update', model);
        let rs = await setting.updateMail(model);
        if(!rs.error) {
          // this.$toastr.s('Saved', this.$route.name);
          if(!this.model.id) { this.refresh(rs.body.id); }
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) }

    },
    setPartner(item) {
      console.log("partner info", item.username, item.id)
      this.so.opt['partner_id'] = item.id
      this.partner_name = item.username;
      this.chainPartner = false;
      this.refresh()
    },
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'partner':
          delete this.so.partner_id
          this.partner_name = '';
          this.chainPartner = false;
          break;
        default:
          break;
      }
      this.refresh()
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(['partner_id', 'category_code', 'target_code'].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.th) { clearTimeout(this.th); this.th = undefined; }
      if(!this.th && this.sync.stop) { this.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        // target : 'mail', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'level':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'target':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.e("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.e("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'last_visit_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.e("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'last_visit_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.e("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      // return Api.Manager(so).then(rs => {
        return setting.listMail(so).then(rs => {
        // rs.body && rs.body.forEach(r =>
        //   codes.target.map(t => { t.meta.value == r.target_code ? r.target_code = t.name : '' }) &&
        //     codes.MAIL_level.map(c => { c.meta.value == r.category_code ? r.category_code = c.name : '' })
        // );
        this.so.totalRows = rs.total;
        return rs.body;
      }).catch(e => {
        console.log(e)
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
      });
    },
    summary() {
      // Api.Manager({ target : 'mail', cmd : 'summary', body : { ts : new Date().getTime() } })
      setting.summaryMail({ ts : new Date().getTime() })
        .then(rs => { this.model = Object.assign(this.model, { enable : (rs.body.total - rs.body.disable), disable : rs.body.disable, total : rs.body.total }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {

      if(this.view_detail === false) { this.$emit("select", item); }
      else {
        this.$router.push({ name : 'mail', params : { id : item.id } });
      }
    },
  },
  created() { console.log('Mail_list.vue', 'created'); this.$root.$on('selected', this.setPartner) },
  destroyed() { console.log('Mail_list.vue', 'destroyed'); },
  mounted() {
    console.log('Mail_list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}